import * as yup from "yup";
import { InferType } from "yup";

export const AchAccountSchema = yup
  .object({
    field_achBankABACode: yup
      .string()
      .required("ABA/Routing Number is required"),
    field_achBankAccountNumber: yup
      .string()
      .required("Bank Account Number is required"),
    field_achBankAccountType: yup.string().required("Account Type is required"),
    field_achBankName: yup.string().required("Bank Name is required"),
    field_achBankAccountName: yup
      .string()
      .required("Account Holder Name is required"),
    field_passthrough4: yup.string().default(""),
    field_passthrough5: yup.string().default(""),
    field_passthrough6: yup.string().default(""),
  })
  .required();

export type AchAccountSchemaType = InferType<typeof AchAccountSchema>;

export const EditAchAccountSchema = yup.object({
  field_achBankABACode: yup.string(),
  field_achBankAccountNumber: yup.string(),
  field_achBankAccountType: yup.string(),
  field_achBankName: yup.string(),
  field_achBankAccountName: yup.string(),
  defaultPayment: yup.boolean(),
  nickname: yup.string(),
});

export type EditAchAccountSchemaType = InferType<typeof EditAchAccountSchema>;
